<div class="product-up-sale" *ngIf="!!productUpSales.length">
  <div class="product-carousel pt-5 mt-0 bg-color">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-10 mx-auto">
          <div class="title">
            <h2>{{ "productUpSales.title" | translate }}</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-10 mx-auto">
          <div class="row product-row">
            <div
              class="col-11 col-sm-8 col-md-7 col-lg-5 col-xl-4 col-xxl-3"
              *ngFor="let item of productUpSales"
            >
              <ng-container *ngIf="item.product">
                <vw-product-card [product]="item.product">
                  <vw-badge
                    [type]="'badge-secondary'"
                    [text]="'upSaleType.' + item.type | translate"
                  ></vw-badge>
                </vw-product-card>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
